const IpTvsIntegrated = ({language , token}) => {
    const newIpTvsIframe = "https:" +
    window.process.env.URL_IpTvs
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_ipTvs_display"
        src={newIpTvsIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default IpTvsIntegrated